import { emailApi } from '@/infrastructure/Configuration'

export default class TransliterationService {
  constructor (httpClient) {
    this._httpClient = httpClient
  }

  async transliterate (data) {
    const url = `${emailApi}/transliterate`

    const response = await this._httpClient.post(url, {
      texts: [{
        text: data
      }]
    })

    return response.data.texts[0].text
  }
}
